export default {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};
